<!-- Topbar -->
<div gsTopbarHeight class="grid transition-all duration-200" [style.grid-template-rows]="topbarOpen() ? '1fr' : '0fr'">
  <div class="overflow-hidden">
    <header-topbar (closeTopbar)="toggleTopbar(false)"></header-topbar>
  </div>
</div>
@let mainbar = headerService.mainbarConfig();
@let defaultMainbar = headerService.DEFAULT_CONFIG.header?.mainbar;
@let defaultMenubar = headerService.DEFAULT_CONFIG.header?.menubar;
@let initData = infoService.init();
@let headerBackgroundColor = config.config()?.header?.backgroundColor ?? headerService.DEFAULT_CONFIG.header?.backgroundColor;
@let menubar = headerService.menubarConfig();
@let headerPadding = config.config()?.header?.padding ?? headerService.DEFAULT_CONFIG.header?.padding;
<nav
  #siteNavigation
  id="site-navigation"
  [attr.aria-label]="'header.aria.navigation' | translate"
  class="relative z-50 flex flex-row items-center justify-between py-2"
  [ngClass]="[styleService.getColorClass(headerBackgroundColor, 'bg'), headerService.useContainer() ? 'container mx-auto' : '']"
  [gsResponsive]="{ padding: headerPadding }"
>
  <!-- Mainbar -->
  @let search = mainbar?.search;
  @let actions = mainbar?.actions;

  @let isMobile = styleService.isMobile('md');
  <!-- LOGO -->
  <!-- `useFullHeight` gives portrait logos more height. The px values must match the h-*/md:h-* classes below, so the
       requested image size stays in sync with the rendered size. -->
  @let logoUseFullHeight = !!mainbar?.logo?.useFullHeight;
  @let logoHeightMobile = logoUseFullHeight ? 48 : 32;
  @let logoHeightDesktop = logoUseFullHeight ? 112 : 64;
  @if (mainbar && mainbar.active && initData && initData.logo && mainbar.logo?.active) {
    <a [href]="headerService.logoLink()" [attr.aria-label]="'header.aria.homepage' | translate" class="flex shrink-0 items-center">
      @for (p of [initData.logo]; track p?.medium ?? 'nopic') {
        <img
          class="w-auto object-contain object-left"
          [class.h-8]="!logoUseFullHeight"
          [class.md:h-16]="!logoUseFullHeight"
          [class.h-12]="logoUseFullHeight"
          [class.md:h-28]="logoUseFullHeight"
          [ngSrc]="imageService.getEndpoint(p, 'medium')!"
          [ngSrcset]="imageService.DEFAULT_SRCSET"
          [loaderParams]="imageService.getLoaderParams(p)"
          [sizes]="
            '(max-width: 768px) ' +
            logoHeightMobile * imageService.getIntrinsicAspectRatio(p) +
            'px, ' +
            logoHeightDesktop * imageService.getIntrinsicAspectRatio(p) +
            'px'
          "
          [width]="imageService.getIntrinsicWidth(p, 'medium')"
          [height]="imageService.getIntrinsicHeight(p, 'medium')"
          alt="Logo"
          priority
        />
      }
    </a>
  } @else if (initData?.companyInfo?.contact?.company) {
    <span
      class="flex h-16 max-w-64 shrink items-center text-2xl font-bold tracking-tight"
      [ngClass]="[styleService.getColorClass(menubar?.textColor ?? defaultMenubar?.textColor ?? 'dark-main', 'text')]"
    >
      {{ initData?.companyInfo?.contact?.company }}
    </span>
  }
  <!-- Menubar -->
  @let menuItems = headerService.dropdownPages();
  @if (menubar && menuItems && menuItems.length > 0) {
    @let menubarAlignment = menubar.alignment ?? defaultMenubar?.alignment ?? 'left';
    @let menuItemFont = styleService.getFontClasses(menubar.font);
    <!-- The configured gap is the maximum, reached at 1920px. Logo, menu and icons share one row, so the gap shrinks
         linearly towards a third at 1400px (where the desktop menu starts) to keep the menu in one line. -->
    @let menuItemGap = menubar.gapBetweenItems ?? defaultMenubar?.gapBetweenItems;
    @let menuItemGapFluid = 'min(' + menuItemGap + 'px, ' + menuItemGap + ' * (100vw - 1100px) / 820)';
    @let menuColors =
      styleService.getColorClass(menubar.textColor ?? defaultMenubar?.textColor ?? 'dark-main', 'text') +
      styleService.getColorClass(menubar.backgroundColor ?? defaultMenubar?.backgroundColor ?? 'light-main', 'bg');
    @let dropdownMenu = menubar.dropdownMenu;
    @let defaultDropdownMenu = defaultMenubar?.dropdownMenu;
    @let dropdownMenuItemFont =
      styleService.getFontClasses(dropdownMenu?.font ?? defaultDropdownMenu?.font ?? menubar.font ?? defaultMenubar?.font);
    @let dropdownMenuItemColors =
      styleService.getColorClass(dropdownMenu?.textColor ?? menubar.textColor ?? defaultMenubar?.textColor ?? 'dark-main', 'text') +
      styleService.getColorClass(menubar.backgroundColor ?? defaultMenubar?.backgroundColor ?? 'light-main', 'bg');
    <ul
      class="navbar-nav xxl:flex hidden w-full flex-row items-center"
      [ngClass]="[
        menuColors,
        menuItemFont,
        headerService.useContainer() ? 'container mx-auto' : 'px-6',
        mainbar?.logo?.useFullHeight ? '' : 'col-span-2',
        menubarAlignment === 'center'
          ? 'justify-center'
          : menubarAlignment === 'right'
            ? 'justify-end'
            : menubarAlignment === 'justify-between'
              ? 'justify-between'
              : 'justify-start'
      ]"
      [style.gap]="menuItemGapFluid"
      [style.fontSize.px]="menubar.textSize ?? defaultMenubar?.textSize"
    >
      @let burgerKeepActiveOnDesktop = !!(menubar.burgerButton?.active && menubar.burgerButton?.keepActiveOnDesktop);
      <!-- BURGER-BUTTON DESKTOP (if option active) -->
      @if (burgerKeepActiveOnDesktop) {
        <li
          [style.paddingTop.px]="menubar.verticalPadding ?? defaultMenubar?.verticalPadding ?? 10"
          [style.paddingBottom.px]="menubar.verticalPadding ?? defaultMenubar?.verticalPadding ?? 10"
        >
          <ng-container [ngTemplateOutlet]="burgerButtonRef" [ngTemplateOutletContext]="{ showOnlyMobile: false }" />
        </li>
      }
      @let menuItemActiveClasses =
        styleService.getColorClass(menubar.activeTextColor ?? defaultMenubar?.activeTextColor ?? 'secondary-main', 'text') +
        styleService.getColorClass(menubar.activeBackgroundColor ?? defaultMenubar?.activeBackgroundColor ?? 'light-shade', 'bg');
      @let dropdownMenuActiveClasses =
        styleService.getColorClass(
          dropdownMenu?.activeTextColor ??
            defaultDropdownMenu?.activeTextColor ??
            menubar.activeTextColor ??
            defaultMenubar?.activeTextColor ??
            'secondary-main',
          'text'
        ) +
        styleService.getColorClass(
          dropdownMenu?.activeBackgroundColor ??
            defaultDropdownMenu?.activeBackgroundColor ??
            menubar.activeBackgroundColor ??
            defaultMenubar?.activeBackgroundColor ??
            'light-shade',
          'bg'
        );
      @let dropdownMenuHoverClasses =
        styleService.getColorClass(
          dropdownMenu?.activeTextColor ??
            defaultDropdownMenu?.activeTextColor ??
            menubar.activeTextColor ??
            defaultMenubar?.activeTextColor ??
            'secondary-main',
          'text',
          'hover:'
        ) +
        styleService.getColorClass(
          dropdownMenu?.activeBackgroundColor ??
            defaultDropdownMenu?.activeBackgroundColor ??
            menubar.activeBackgroundColor ??
            defaultMenubar?.activeBackgroundColor ??
            'light-shade',
          'bg',
          'hover:'
        );

      <!-- Hide the desktop menu items when the burger-button stays active on desktop (sidebar is used instead) -->
      @if (!burgerKeepActiveOnDesktop) {
        @for (menuItem of menuItems; track headerService.trackHeaderMenu(menuItem)) {
          @let isCurrentPage = headerService.isMenuItemOrChildActive(menuItem, system.currentRelativeLink());
          @let isExternalLink = menuItem.linkUrl?.startsWith('http');
          <!-- Menu items without a linked page arrive with linkUrl '' — href="" would resolve to the homepage -->
          @let hasLink = !!menuItem.linkUrl;
          @let hasChildren = menuItem.items.length > 0;
          @let menuItemPadding = menubar.verticalPadding ?? defaultMenubar?.verticalPadding ?? 10;
          <!-- The menus sit next to the link, not inside: their own links inside an <a> break the HTML (and the SSR hydration) -->
          @switch (menuItem.menuType) {
            @case (headerService.MenuType.MegaMenu) {
              <li
                [style.paddingTop.px]="menuItemPadding"
                [style.paddingBottom.px]="menuItemPadding"
                class="nav-item dropdown dropdown-fullwidth"
                (mouseenter)="toggleDropdownOf(megamenuComp, $event, menuItem)"
                (mouseleave)="toggleDropdownOf(megamenuComp, $event, menuItem)"
              >
                <a
                  [attr.href]="hasLink ? menuItem.linkUrl : null"
                  [attr.target]="hasLink ? (isExternalLink ? '_blank' : (menuItem.linkTarget ?? '_self')) : null"
                  [attr.rel]="hasLink && isExternalLink ? 'noopener noreferrer' : null"
                  [attr.role]="!hasLink && hasChildren ? 'button' : null"
                  [attr.tabindex]="!hasLink && hasChildren ? 0 : null"
                  [attr.aria-haspopup]="!hasLink && hasChildren ? 'menu' : null"
                  [attr.aria-expanded]="!hasLink && hasChildren ? megamenuComp.opened() : null"
                  [attr.aria-disabled]="!hasLink && !hasChildren ? true : null"
                  [ngClass]="[
                    isCurrentPage ? menuItemActiveClasses : '',
                    !hasLink && !hasChildren ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
                  ]"
                  (keydown)="headerService.handleDropdownKeydown(megamenuComp, $event, menuItem)"
                  class="inline-flex items-center gap-1 pl-1 md:gap-1.5"
                >
                  <span
                    class="text-nowrap"
                    [ngClass]="{
                      underline: isCurrentPage && (menubar.activeUnderlined ?? defaultMenubar?.activeUnderlined ?? false)
                    }"
                  >
                    {{ menuItem.label }}
                  </span>
                  @if (menuItem.items.length > 0) {
                    <gs-icon
                      class="text-sm transition-transform duration-200 ease-in-out motion-reduce:transition-none"
                      [ngClass]="[
                        styleService.getColorClass(actions?.iconColor ?? defaultMainbar?.actions?.iconColor ?? 'secondary-main', 'text'),
                        megamenuComp.opened() ? 'rotate-180' : ''
                      ]"
                      iconName="caret-down"
                      iconWeight="light"
                    ></gs-icon>
                  }
                </a>
                <!-- The menu items sit inside the mainbar row, so anchor the menus to the nav to open them below the header -->
                <megamenu
                  #megamenuComp
                  [items]="menuItem.items"
                  [anchor]="siteNavigation"
                  [showItemPhotos]="false"
                  [showItemGlyphs]="false"
                  [menuItemClasses]="dropdownMenuItemFont + ' px-4 py-2'"
                  [menuItemColorClasses]="dropdownMenuItemColors"
                  [activeMenuItemClasses]="dropdownMenuActiveClasses"
                  [hoverMenuItemClasses]="dropdownMenuHoverClasses"
                  [activeUnderlined]="
                    dropdownMenu?.activeUnderlined ??
                    defaultDropdownMenu?.activeUnderlined ??
                    menubar.activeUnderlined ??
                    defaultMenubar?.activeUnderlined ??
                    false
                  "
                  [menuClasses]="styleService.getColorClass(headerBackgroundColor, 'bg') + ' shadow-lg w-full pt-4 pb-2'"
                  [style.fontSize.px]="dropdownMenu?.textSize ?? defaultDropdownMenu?.textSize"
                ></megamenu>
              </li>
            }
            @case (headerService.MenuType.Dropdown) {
              <li
                [style.paddingTop.px]="menuItemPadding"
                [style.paddingBottom.px]="menuItemPadding"
                class="nav-item dropdown"
                (mouseenter)="toggleDropdownOf(dropdownComp, $event, menuItem)"
                (mouseleave)="toggleDropdownOf(dropdownComp, $event, menuItem)"
              >
                <a
                  [attr.href]="hasLink ? menuItem.linkUrl : null"
                  [attr.target]="hasLink ? (isExternalLink ? '_blank' : (menuItem.linkTarget ?? '_self')) : null"
                  [attr.rel]="hasLink && isExternalLink ? 'noopener noreferrer' : null"
                  [attr.role]="!hasLink && hasChildren ? 'button' : null"
                  [attr.tabindex]="!hasLink && hasChildren ? 0 : null"
                  [attr.aria-haspopup]="!hasLink && hasChildren ? 'menu' : null"
                  [attr.aria-expanded]="!hasLink && hasChildren ? dropdownComp.opened() : null"
                  [attr.aria-disabled]="!hasLink && !hasChildren ? true : null"
                  [ngClass]="[
                    isCurrentPage ? menuItemActiveClasses : '',
                    !hasLink && !hasChildren ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
                  ]"
                  (keydown)="headerService.handleDropdownKeydown(dropdownComp, $event, menuItem)"
                  class="inline-flex items-center gap-1 pl-1 md:gap-1.5"
                >
                  <span
                    class="text-nowrap"
                    [ngClass]="{
                      underline: isCurrentPage && (menubar.activeUnderlined ?? defaultMenubar?.activeUnderlined ?? false)
                    }"
                  >
                    {{ menuItem.label }}
                  </span>
                  @if (menuItem.items.length > 0) {
                    <gs-icon
                      class="text-sm transition-transform duration-200 ease-in-out motion-reduce:transition-none"
                      [ngClass]="[
                        styleService.getColorClass(actions?.iconColor ?? defaultMainbar?.actions?.iconColor ?? 'secondary-main', 'text'),
                        dropdownComp.opened() ? 'rotate-180' : ''
                      ]"
                      iconName="caret-down"
                      iconWeight="light"
                    ></gs-icon>
                  }
                </a>
                <dropdown
                  #dropdownComp
                  [items]="menuItem.items"
                  [anchor]="siteNavigation"
                  [openSubmenusInline]="false"
                  [showItemPhotos]="false"
                  [showItemGlyphs]="false"
                  [menuItemClasses]="dropdownMenuItemFont + ' px-4 py-2'"
                  [menuItemColorClasses]="dropdownMenuItemColors"
                  [activeMenuItemClasses]="dropdownMenuActiveClasses"
                  [hoverMenuItemClasses]="dropdownMenuHoverClasses"
                  [activeUnderlined]="
                    dropdownMenu?.activeUnderlined ??
                    defaultDropdownMenu?.activeUnderlined ??
                    menubar.activeUnderlined ??
                    defaultMenubar?.activeUnderlined ??
                    false
                  "
                  [menuClasses]="styleService.getColorClass(headerBackgroundColor, 'bg') + ' shadow-md min-w-48 py-1'"
                  [ariaLabel]="menuItem.label + ' menu'"
                  [style.fontSize.px]="dropdownMenu?.textSize ?? defaultDropdownMenu?.textSize"
                ></dropdown>
              </li>
            }
            @case (headerService.MenuType.Highlight) {
              <!-- TODO: Highlighted Menu Items coming soon -->
            }
          }
        }
      }
    </ul>
  }
  <div class="ml-auto flex shrink-0 flex-row items-center justify-end text-xl">
    <!-- MYCHAINSTORE DESKTOP -->
    @let myChainstore = mainbar?.myChainstore;
    @let myChainstoreMode = myChainstore?.displayMode ?? 'both';
    @if (myChainstore && myChainstore.active && myChainstore.icon && myChainstoreMode !== 'sidemenu') {
      @let myChainstoreLabel = myChainstoreService.current()?.name ?? ('header.mainbar.myChainstore.label' | translate);
      <button
        class="group flex shrink-0 cursor-pointer flex-row items-center justify-start bg-transparent text-left duration-200"
        [aria-label]="myChainstoreLabel"
        [title]="myChainstoreLabel"
        [attr.aria-expanded]="myChainstoreService.panelOpen()"
        aria-haspopup="dialog"
        [ngClass]="[
          styleService.getColorClass(actions?.iconColor ?? 'secondary-main', 'text'),
          styleService.getColorClass(actions?.iconColorHover ?? 'secondary-shade', 'text', 'hover:')
        ]"
        [style.marginRight.px]="isMobile ? 20 : (actions?.gap ?? defaultMainbar?.actions?.gap ?? 20)"
        (click)="myChainstoreService.openPanel()"
      >
        <gs-icon
          [iconName]="myChainstore.icon.name"
          [iconWeight]="myChainstore.icon.weight"
          [animation]="myChainstore.icon.animation"
        ></gs-icon>
        @if (showChainstoreLabel()) {
          <span class="hidden w-40 shrink-0 flex-col pl-3 lg:flex">
            <span class="p-small text-medium-main truncate text-sm leading-none">
              {{ 'header.mainbar.myChainstore.label' | translate }}
            </span>
            <span class="p-small text-dark-main truncate leading-none group-hover:underline">
              {{ myChainstoreService.current()?.name ?? ('header.mainbar.myChainstore.notSelected' | translate) }}
            </span>
          </span>
        }
      </button>
    }
    <!-- SEARCH -->
    <typeahead #typeaheadRef [showFullSize]="!mainbar?.search?.showAsModal" [borderRadius]="mainbar?.search?.borderRadius"></typeahead>
    @if (search && search.active && search.icon) {
      @let searchLabel = 'header.actionButtons.search' | translate;
      <button
        class="flex cursor-pointer flex-row items-center justify-start bg-transparent text-left duration-200"
        [aria-label]="searchLabel"
        [title]="searchLabel"
        [ngClass]="[
          styleService.getColorClass(actions?.iconColor ?? 'secondary-main', 'text'),
          styleService.getColorClass(actions?.iconColorHover ?? 'secondary-shade', 'text', 'hover:')
        ]"
        [style.marginRight.px]="isMobile ? 20 : (actions?.gap ?? defaultMainbar?.actions?.gap ?? 20)"
        (click)="typeaheadRef.showSearchInput.set(true)"
      >
        <gs-icon [iconName]="search.icon.name" [iconWeight]="search.icon.weight" [animation]="search.icon.animation"></gs-icon>
      </button>
    }
  </div>
  @let actionsContrastColor = colorService.getContrastColorOf(actions?.iconColor ?? 'secondary-main');
  @let actionLinkList = headerService.actionLinks();
  <span
    class="flex shrink-0 flex-row items-center text-xl"
    [style.gap.px]="isMobile ? 20 : (actions?.gap ?? defaultMainbar?.actions?.gap ?? 20)"
    [ngClass]="[styleService.getColorClass(actions?.iconColor ?? 'secondary-main', 'text')]"
  >
    @if (actionLinkList) {
      @for (action of headerService.mainbarActions() | keyvalue | orderBy: 'desc' : 'value.orderIndex'; track action.key) {
        @let actionVal = action.value;
        @let shownIfLoggedIn = headerService.CONFIG_HEADER_ACTIONS_NEEDS_LOGIN.includes(action.key) ? headerService.isLoggedIn() : true;
        @let shownIfNotLoggedIn =
          headerService.CONFIG_HEADER_ACTIONS_WITHOUT_LOGIN.includes(action.key) ? !headerService.isLoggedIn() : true;
        @let shownIfWebshop = headerService.CONFIG_HEADER_ACTIONS_NEEDS_WEBSHOP.includes(action.key) ? system.isWebshop : true;
        @let shownIfInquiry = headerService.CONFIG_HEADER_ACTIONS_NEEDS_INQUIRY.includes(action.key) ? !!initData?.hasInquiry : true;
        @if (actionVal && shownIfLoggedIn && shownIfNotLoggedIn && shownIfWebshop && shownIfInquiry) {
          @let label = 'header.actionButtons.' + action.key | translate;
          <!-- The configured per-breakpoint visibility is resolved in CSS, so the wrapper is `display: contents` while active and `none` otherwise. -->
          <span [gsResponsive]="{ visible: actionVal.active ?? false }">
            @if (actionLinkList[action.key]) {
              <a
                class="group relative flex cursor-pointer items-center duration-200"
                [href]="actionLinkList[action.key]"
                [aria-label]="label"
                [title]="label"
                [ngClass]="[styleService.getColorClass(actions?.iconColorHover ?? 'secondary-shade', 'text', 'hover:')]"
              >
                <ng-container *ngTemplateOutlet="innerActionRef"></ng-container>
              </a>
            } @else {
              <button
                class="group relative flex cursor-pointer items-center duration-200"
                (click)="handleActionClick(action.key, $event)"
                [aria-label]="label"
                [title]="label"
                [ngClass]="[styleService.getColorClass(actions?.iconColorHover ?? 'secondary-shade', 'text', 'hover:')]"
              >
                <ng-container *ngTemplateOutlet="innerActionRef"></ng-container>
              </button>
            }
          </span>
          <ng-template #innerActionRef>
            @if (actionVal.icon) {
              <gs-icon [iconName]="actionVal.icon.name" [iconWeight]="actionVal.icon.weight" [animation]="actionVal.icon.animation"></gs-icon>
            }
            @if (action.key === 'watchlist' || action.key === 'shoppingcart' || action.key === 'inquiry_shoppingcart') {
              <span
                class="absolute -top-1 -right-2.5 flex size-5 items-center justify-center rounded-full text-center text-xs"
                [ngClass]="[
                  styleService.getColorClass(actions?.iconColor ?? 'secondary-main', 'bg'),
                  styleService.getColorClass(actionsContrastColor, 'text')
                ]"
              >
                {{
                  (action.key === 'watchlist'
                    ? watchlist.amount
                    : action.key === 'shoppingcart'
                      ? basket.count
                      : basket.requestListCount) ?? 0
                }}
              </span>
            }
          </ng-template>
        }
      }
    }
  </span>
  <ng-container [ngTemplateOutlet]="burgerButtonRef" [ngTemplateOutletContext]="{ showOnlyMobile: true }" />

  <ng-template #burgerButtonRef let-showOnlyMobile="showOnlyMobile">
    @if (menubar && menubar.burgerButton && menubar.burgerButton.active) {
      @let burgerButtonIcon =
        menubar.burgerButton.icon ??
        defaultMenubar?.burgerButton?.icon ?? {
          name: 'list',
          weight: 'fill'
        };
      @let burgerButtonColor = menubar.burgerButton.color ?? defaultMenubar?.burgerButton?.color ?? 'secondary-main';
      @let menuActiveTextColor = menubar.activeTextColor ?? defaultMenubar?.activeTextColor ?? 'secondary-main';
      <button
        class="xxl:mr-0 flex cursor-pointer border-none bg-transparent text-xl duration-200 ease-in-out"
        (click)="system.toggleSidebar()"
        aria-controls="sidebar-nav"
        [attr.aria-expanded]="system.sidebarOpen()"
        [attr.aria-label]="(system.sidebarOpen() ? 'header.sideBar.closeMenu' : 'header.sideBar.openMenu') | translate"
        [ngClass]="[
          styleService.getColorClass(burgerButtonColor, 'text'),
          styleService.getColorClass(menuActiveTextColor, 'text', 'hover:'),
          showOnlyMobile ? 'xxl:hidden' : ''
        ]"
        [style.marginLeft.px]="showOnlyMobile ? (isMobile ? 22 : (actions?.gap ?? defaultMainbar?.actions?.gap ?? 15)) : 0"
        [style.marginRight.px]="showOnlyMobile ? 8 : null"
      >
        <gs-icon [iconName]="burgerButtonIcon.name" [iconWeight]="burgerButtonIcon.weight" [animation]="burgerButtonIcon.animation"></gs-icon>
      </button>
    }
  </ng-template>
</nav>

<!-- SIDEBAR -->
<header-sidebar></header-sidebar>

<!-- MYCHAINSTORE PANEL -->
@if (config.config()?.header?.mainbar?.myChainstore?.active) {
  <my-chainstore></my-chainstore>
}
